<template>
    <router-view v-slot="{ Component }">
        <keep-alive>
            <component :is="Component" />
        </keep-alive>
    </router-view>
    <q-resize-observer @resize="onResize" />
</template>

<script>
import { mapActions } from "vuex";

import { useStore } from "vuex";
export default {
    created() {
        this.actLoadSetting();
    },
    setup() {
        const store = useStore()
        const onResize = () => {
            store.dispatch("actSetClientSize", {
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        return {
            onResize
        }
    },
    methods: {
        ...mapActions("appSetting", ["actLoadSetting"]),
    },
};
</script>